// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "#575757";
var _3 = "deleteButton-rwAx";
var _4 = "1.5rem";
var _5 = "#dedede";
var _6 = "#adf";
var _7 = "1rem";
var _8 = "#bebebe";
var _9 = "saveButton-Aiba";
var _a = "saveButtonBase-wPwy";
var _b = "savePreventedNotificationButton-m_RB";
var _c = ".8rem";
var _d = "#000";
var _e = "warningButton-KZPE";
export { _1 as "busBlue", _2 as "darkGrey", _3 as "deleteButton", _4 as "extraLargeFontSize", _5 as "lightGrey", _6 as "lightblue", _7 as "mediumFontSize", _8 as "mediumLightGrey", _9 as "saveButton", _a as "saveButtonBase", _b as "savePreventedNotificationButton", _c as "smallFontSize", _d as "unusedNodeColor", _e as "warningButton" }
